export default function PHP_Install() {
  return (
    <div>
      <h1>PHP_Install</h1>
    </div>
  );
}
